import RcResponseEvent from '@/domain/model/events/RcResponseEvent.js';

export default class RcEventListener {

  constructor(domain, listener, context) {
    this.domain = domain;
    this.logger = domain.logger();
    this.listener = listener;
    this.context = context;
    this.finished = false;
  }

  emit(event) {
    // The events store only drops a listener 250 ms after a reply arrives, so a
    // second copy of the same reply can reach it. The list pages delete
    // context.model once they have loaded, and a repeat call then failed with
    // "Cannot set properties of undefined (setting '_total')". A listener that
    // has said it is done hears nothing more.
    if (this.finished) {
      return false;
    }
    var responseEvent = this.domain.events().findByData(event);
    if (responseEvent == null) {
      responseEvent = new RcResponseEvent(this.domain, event);
    }
    //this.logger.info(JSON.stringify(responseEvent.data, null, 2));
    this.logger.info("Received Response {1} ({0}) {2}", [responseEvent.data['@rid'], responseEvent.data['eventName'], this.listener.name]);
    var inProgress = this.listener(responseEvent, this.context);
    if (!inProgress) {
      this.finished = true;
    }
    return inProgress;
  }
}
